<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate">
              {{ $t("messages.playerReport.playerReport") }}
            </h2>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"></div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav class="bg-white border-b border-t border-gray-200 flex" aria-label="Breadcrumb">
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a href="javascript:void(0)" class="text-gray-400 hover:text-gray-500">
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg class="flex-shrink-0 w-6 h-full text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link :to="page.href" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined">{{ page.name }}</router-link>
          </div>
        </li>
      </ol>
    </nav>

    <div class="">
      <div class="space-y-8 divide-y divide-gray-200 bg-white py-3 border-b text-center">
        <div class="flex md:flex-row flex-col justify-center md:items-center md:justify-between">
          <div class="flex-1 px-2 flex justify-center lg:ml-6 lg:justify-start">
            <div class="max-w-lg w-56 lg:max-w-xs">
              <label for="search" class="sr-only">Search</label>
              <div class="relative text-gray-400 focus-within:text-gray-600">
                <div class="pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center">
                  <SearchIcon class="h-5 w-5" aria-hidden="true" />
                </div>
                <input id="search" v-model="searchInput" maxlength="10" @keyup="searchText($event)"
                  class="block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                  type="search" name="search" :placeholder="$t('messages.playerReport.search')" />
              </div>
            </div>
            <Listbox as="div" v-model="selected">
              <div class="relative w-48">
                <ListboxButton
                  class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                  <span class="block truncate">{{ selected.label }}</span>
                  <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                  </span>
                </ListboxButton>

                <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                  leave-to-class="opacity-0">
                  <ListboxOptions
                    class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                    <ListboxOption as="template" v-for="month in months" :key="month.label" :value="month"
                      @click="search(month)">
                      <li :class="[
                        'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                      ]">
                        <span :class="[
                          selected.value == month.value
                            ? 'font-semibold'
                            : 'font-normal',
                          'block truncate text-left',
                        ]">
                          {{ month.label }}
                        </span>

                        <span v-if="selected.value == month.value" :class="[
                          'absolute inset-y-0 right-0 flex items-center pr-4 pl-5',
                        ]">
                          <CheckIcon class="h-5 w-5" aria-hidden="true" />
                        </span>
                      </li>
                    </ListboxOption>
                  </ListboxOptions>
                </transition>
              </div>
            </Listbox>
          </div>
          <div class="flex flex-row gap-y-2 flex-wrap lg:flex-nowrap justify-center">
            <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8">
              <button type="button" @click="filterModal"
                class="ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500">
                <font-awesome-icon class="text-white mr-2" :icon="['far', 'filter']" transform="" />
                {{ $t("messages.playerReport.advanceFilter") }}
              </button>
            </div>
            <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8">
              <button type="button" @click="exports()"
                class="ml-3 inline-flex items-center px-4 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500">
                <font-awesome-icon class="mr-2" :icon="['far', 'file-export']" />
                {{ $t("messages.playerReport.exportReport") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="px-8 py-6" v-show="!isLoaded">
      <div
        class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center"
      >
        <font-awesome-icon
          class="text-gray-500"
          :icon="['fas', 'circle-notch']"
          transform="grow-6"
          spin
        />
      </div>
    </div> -->

    <div class="relative py-6">
      <div class="sm:px-6 md:px-8">
        <div class="bg-white shadow sm:rounded-md">
          <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
            <div v-if="!isLoaded"
              class="absolute inset-0 bg-gray-100 bg-opacity-75 flex justify-center items-center z-50">
              <div class="loader"></div>
              <p class="text-gray-700 text-lg">Loading...</p>
            </div>
            <table class="table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" @click="doSort('userName')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                    {{ $t("messages.playerReport.user") }}
                  </th>
                  <th scope="col" @click="doSort('moduleCode')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                    {{ $t("messages.playerReport.providerName") }}
                  </th>
                  <th scope="col" @click="doSort('betCount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer">
                    {{ $t("messages.playerReport.totalBetRounds") }}
                  </th>
                  <th scope="col" @click="doSort('betAmount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.playerReport.betAmount") }}
                  </th>
                  <th scope="col" @click="doSort('validBetAmount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.playerReport.validBetAmount") }}
                  </th>
                  <th scope="col" @click="doSort('winLoss')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.playerReport.winloss") }}
                  </th>
                  <th scope="col" @click="doSort('winLossPercentage')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.playerReport.winlossPercent") }}
                  </th>
                  <th scope="col" @click="doSort('date')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer">
                    {{ $t("messages.playerReport.date") }}
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="data in dataRows" :key="data.id" class="hover:bg-gray-50">
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500" style="color: #4169e1">
                    {{ data.userName }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ data.gameId }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      data.totalBet.toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      (data.betAmount / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      (data.validBetAmount / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right" :style="parseFloat(data.winLoss / 100) >= 0
                      ? { color: 'green' }
                      : { color: 'red' }
                    ">
                    {{
                      (data.winLoss / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right" :style="parseFloat(data.winLossPercentage) >= 0
                      ? { color: 'green' }
                      : { color: 'red' }
                    ">
                    <span v-if="data.winLossPercentage">{{
                      (data.winLossPercentage * 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 4,
                      })
                    }}%</span>
                    <span v-else> - </span>
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{ dayjs(data.date).format("LL") }}
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination v-model:config="pageConfig" isLagacy />
            <!-- <div
              class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
            >
              <div
                class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between"
              >
                <div>
                 
                  <Listbox as="div" v-model="rowsPerPage">
                    <ListboxButton
                      class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    >
                      <span class="block truncate">{{
                        rowsPerPage.value
                      }}</span>
                      <span
                        class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                      >
                        <SelectorIcon
                          class="h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </span>
                    </ListboxButton>
                    <ListboxOptions
                      class="absolute z-10 mt-1 w-44 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                    >
                      <ListboxOption
                        as="template"
                        v-for="(option, index) in rowsPerPageOption"
                        :key="index"
                        :value="option"
                        @click="setRowsPerPage()"
                      >
                        <li
                          :class="[
                            'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                          ]"
                        >
                          <span
                            :class="[
                              selected.value == rowsPerPageOption.value
                                ? 'font-semibold'
                                : 'font-normal',
                              'block truncate text-left',
                            ]"
                          >
                            {{ option.label }}
                          </span>

                          <span
                            v-if="selected.value == rowsPerPageOption.value"
                            :class="[
                              'absolute inset-y-0 right-0 flex items-center pr-4 pl-5',
                            ]"
                          >
                            <CheckIcon class="h-5 w-5" aria-hidden="true" />
                          </span>
                        </li>
                      </ListboxOption>
                    </ListboxOptions>
                  </Listbox>

                  <p class="text-sm text-gray-700">
                    Showing

                    {{ " " }}
                    <span v-if="offset === 0" class="font-medium">
                      1 to {{ rowsPerPage.value }}
                    </span>
                    <span v-else>
                      <span
                        class="font-medium"
                        v-if="
                          currentPage ===
                          Math.ceil(dataCount / rowsPerPage.value)
                        "
                      >
                        {{ offset + 1 }} to {{ dataCount }}
                      </span>
                      <span class="font-medium" v-else>
                        {{ offset + 1 }} to
                        {{ currentPage * rowsPerPage.value }}
                      </span>
                    </span>

                    of

                    <span class="font-medium">{{ dataCount }}</span>

                    results
                  </p>
                </div>
                <div>
                  <nav
                    class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                    aria-label="Pagination"
                  >
                    <a
                      href="javascript:void(0)"
                      @click="jump(1)"
                      class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    >
                      <span class="sr-only">First</span>
                      <span class="h-5 w-5 text-center"
                        ><font-awesome-icon
                          class="text-gray-500"
                          :icon="['fas', 'chevron-double-left']"
                          transform="shrink-2"
                      /></span>
                    </a>

                    <a
                      href="javascript:void(0)"
                      @click="prev"
                      class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    >
                      <span class="sr-only">Previous</span>
                      <span class="h-5 w-5 text-center"
                        ><font-awesome-icon
                          class="text-gray-500"
                          :icon="['fas', 'chevron-left']"
                          transform="shrink-2"
                      /></span>
                    </a>

                    <div
                      href="javascript:void(0)"
                      @click="jump(paginationOffset(pageNumber))"
                      v-for="pageNumber in pageCount"
                      :key="pageNumber"
                      :class="
                        currentPage === pageNumber
                          ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-block items-center py-2 w-10 text-center border text-sm font-medium'
                          : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-block items-center py-2 w-10 text-center border text-sm font-medium'
                      "
                      :style="{
                        display:
                          Math.abs(pageNumber - currentPage) < 2 ||
                          pageNumber == 0
                            ? 'block'
                            : 'none',
                      }"
                      style="cursor: pointer"
                    >
                      <div>
                        {{ pageNumber }}
                      </div>
                    </div>

                    <a
                      href="javascript:void(0)"
                      @click="next"
                      class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    >
                      <span class="sr-only">Next</span>
                      <span class="h-5 w-5 text-center"
                        ><font-awesome-icon
                          class="text-gray-500"
                          :icon="['fas', 'chevron-right']"
                          transform="shrink-2"
                      /></span>
                    </a>
                    <a
                      href="javascript:void(0)"
                      @click="jump(Math.ceil(dataCount / rowsPerPage.value))"
                      class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    >
                      <span class="sr-only">Last</span>
                      <span class="h-5 w-5 text-center"
                        ><font-awesome-icon
                          class="text-gray-500"
                          :icon="['fas', 'chevron-double-right']"
                          transform="shrink-2"
                      /></span>
                    </a>
                  </nav>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <TransitionRoot as="template" :show="advanceFilterModal">
      <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="advanceFilterModal = false"
        :open="advanceFilterModal">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
            leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div class="mt-2 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    Advance Filter
                    <!-- <small class="text-gray-400">{{ userInfo.username }}</small> -->
                  </DialogTitle>
                  <div class="rounded-md bg-red-50 p-4 text-left mt-3" v-show="hasError">
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <XCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
                      </div>
                      <div class="ml-3">
                        <h3 class="text-sm font-medium text-red-800">
                          {{ errorMessage }}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div class="mt-6 pb-2 text-left">
                    <label class="text-sm">{{
                      $t("messages.playerReport.user")
                    }}</label>
                    <div class="mt-1">
                      <input type="text" v-model="filterForm.userName" name="phoneNumber" id="phoneNumber"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                    </div>
                  </div>
                  <div class="mt-6 pb-2 text-left">
                    <label class="text-sm">{{
                      $t("messages.playerReport.providerName")
                    }}</label>
                    <div class="mt-1">
                      <input type="text" v-model="filterForm.gameId" name="phoneNumber" id="phoneNumber"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button type="button" @click="filterModal(1)"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm">
                  {{ $t("messages.playerReport.filter") }}
                </button>
                <button type="button" @click="filterModal()"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  ref="cancelButtonRef">
                  {{ $t("messages.playerReport.cancel") }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  XCircleIcon,
} from "@heroicons/vue/solid";
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import {
  computed,
  inject,
  onMounted,
  ref,
  watchEffect,
  watch,
} from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";
import stringify from "qs-stringify";
import Pagination from "@/components/tools/Pagination.vue";

dayjs.extend(localizedFormat);

const pages = [{ name: "Player Report", href: "", current: true }];
const rowsPerPageOption = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "30", value: 30 },
  { label: "40", value: 40 },
];

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    XCircleIcon,
    Pagination,
  },
  setup() {
    const currentPage = ref(1);
    const offset = ref(0);
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const toDate = ref("");
    const startPaginationPage = ref(1);
    const rowsPerPage = ref({ label: "10", value: 10 });
    const startDate = dayjs();
    const diff = startDate.diff("2021-07-01", "months");
    let months = ref([]);
    let advanceFilterModal = ref(false);
    let filterForm = ref({
      userName: null,
      gameId: null,
      date: null,
    });

    const pageConfig = ref({
      page: route.query.page || 1,
      count: 0,
      pageCount: 0,
      rowsPerPage: 10,
      dataLength: 0,
      search: undefined,
      sort: [["created_at", "DESC"]],
    });

    for (let i = 0; i <= diff; i++) {
      months.value.push({
        label: dayjs("2021-07-01").add(i, "month").format("MM/YYYY"),
        value: dayjs("2021-07-01").add(i, "month").format(),
      });
    }
    months.value.sort((a, b) => (dayjs(b.value).isAfter(dayjs(a.value)) ? 1 : -1));


    const setRowsPerPage = () => {
      let limit = rowsPerPage.value.value || 10;
      if (
        offset === Math.ceil(dataCount.value / rowsPerPage.value.value) &&
        offset !== 0
      ) {
        let rowOffset = rowsPerPage.value.value * offset - dataCount.value;
        limit = rowsPerPage.value.value - rowOffset;
      }
      let sort = sortBy.value.length ? sortBy.value : [["created_at", "DESC"]];
      let fromParams = dayjs(selected.value.value).startOf("month").format();
      let toParams = dayjs(selected.value.value).endOf("month").format();
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/report/player-game-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
              offset:
                pageConfig.value.rowsPerPage * (pageConfig.value.page - 1),
              limit: pageConfig.value.rowsPerPage,
              sort,
            },
          }
        )
        .then(({ data }) => {
          dataRows.value = data.result.rows;
          dataCount.value = data.result.count;
          pageConfig.value.dataLength = data.result.rows.length;
          window.history.replaceState(
            {},
            document.title,
            `player?${stringify({
              page: pageConfig.value.page,
              rowsPerPage: pageConfig.value.rowsPerPage,
            })}`
          );
          isLoaded.value = true;
        })
        .catch((err) => {
          console.log(err);
          isLoaded.value = true;
        });
    };

    const selected = ref(months.value[0]);

    let dataRows = ref([]);
    let dataCount = ref(1);
    let isLoaded = ref(false);
    let searchInput = ref("");
    let sortBy = ref([]);
    let isFilter = ref(false);
    let isSearch = ref(false);
    let errorMessage = ref("");
    let hasError = ref(false);

    onMounted(() => {
      refetch();
    });

    const refetch = () => {
      isLoaded.value = false;
      if (isFilter.value == true) {
        filterData(parseInt(route.query.page));
        return;
      }

      if (isSearch.value == true) {
        searchText(null, true);
        return;
      }

      let sort = sortBy.value.length ? sortBy.value : [["created_at", "DESC"]];

      let fromParams = dayjs(selected.value.value).startOf("month").format();
      let toParams = dayjs(selected.value.value).endOf("month").format();
      // console.log(fromParams, toParams)
      setRowsPerPage();
    };

    const search = (month) => {
      let from = dayjs(month.value);
      let fromParams = dayjs(month.value).startOf("month").format();
      let toParams = dayjs(month.value).endOf("month").format();

      if (from.isValid()) {
        isLoaded.value = false;
        setRowsPerPage();
      }
    };
    const viewData = (data) => {
      router.push({ name: "Wallet Info", params: { id: data.id } });
    };

    const searchText = (e = null, bypass = null) => {
      if (
        ((e && (e.code == "Enter" || e.code == "NumpadEnter" || e.keyCode == 13)) || bypass) &&
        searchInput.value.length >= 2
      ) {
        isLoaded.value = false;
        let fromParams = dayjs(selected.value.value).startOf("month").format();
        let toParams = dayjs(selected.value.value).endOf("month").format();
        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT +
            "/admin/api/v1/report/player-game-op",
            null,
            {
              params: {
                operatorId: store.state.selectedOperator.operatorId,
                from: fromParams,
                to: toParams,
                search: searchInput.value,
                offset:
                  pageConfig.value.rowsPerPage * (pageConfig.value.page - 1),
                limit: pageConfig.value.rowsPerPage,
              },
            }
          )
          .then(({ data }) => {
            // console.log(data)
            dataRows.value = data.result.rows;
            dataCount.value = data.result.count;
            pageConfig.value.dataLength = data.result.rows.length;
            isLoaded.value = true;
            isSearch.value = true;
            isFilter.value = false;
          })
          .catch((err) => {
            console.log(err);
            isLoaded.value = true;
          });
      } else if (searchInput.value.length == 0) {
        refetch();
      }
    };

    const filterModal = (flag = false) => {
      advanceFilterModal.value = !advanceFilterModal.value;

      if (flag == 1) filterData();
    };

    const filterData = (page = 0) => {
      hasError.value = false;

      let build_fillter = {
        playerName: filterForm.value.userName,
        gameType: filterForm.value.gameId,
      };

      let fromParams = dayjs(selected.value.value).startOf("month").format();
      let toParams = dayjs(selected.value.value).endOf("month").format();

      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/report/player-game-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
              offset:
                pageConfig.value.rowsPerPage * (pageConfig.value.page - 1),
              limit: pageConfig.value.rowsPerPage,
              ...build_fillter,
            },
          }
        )
        .then(({ data }) => {
          // console.log(data)
          if (data.result.length == 1) {
            router.push({
              name: "Wallet Info",
              params: { id: data.result[0].id },
            });
            return;
          }

          dataRows.value = data.result.rows;
          dataCount.value = data.result.count;
          pageConfig.value.dataLength = data.result.rows.length;
          isLoaded.value = true;
          isFilter.value = true;
          isSearch.value = false;
        })
        .catch((err) => {
          hasError.value = true;
          console.log(err);
        });
    };

    const doSort = (attName) => {
      if (sortBy.value[0] && sortBy.value[0][0] == attName) {
        sortBy.value[0][1] = sortBy.value[0][1] == "DESC" ? "ASC" : "DESC";
      } else {
        sortBy.value = [[attName, "DESC"]];
      }
      isFilter.value = false;
      refetch();
    };

    const paginationOffset = (i) => {
      return (parseInt(route.query.page) || 1) < 4
        ? i
        : parseInt(route.query.page) > Math.floor(dataCount.value / 10) - 3
          ? Math.floor(dataCount.value / 10) - 6 + i
          : route.query.page - 4 + i;
    };

    const exports = () => {
      let fromParams = dayjs(selected.value.value).startOf("month").format();
      let toParams = dayjs(selected.value.value).endOf("month").format();

      let build_fillter = {
        playerName: filterForm.value.userName,
        gameType: filterForm.value.gameId,
      };
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/report/export/player-game-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
              ...build_fillter,
            },
          }
        )
        .then(({ data }) => {
          window.open(data.result);
        });
    };

    watch(
      () => pageConfig.value.page,
      () => refetch()
    );
    watch(
      () => pageConfig.value.search,
      // () => pageConfig.value.rowsPerPage,
      () => {
        pageConfig.value.page = 1;
        refetch();
      }
    );
    /** fetch data when rows per page was changed */
    watch(
      () => pageConfig.value.rowsPerPage,
      () => {
        pageConfig.value.page = Number(route.query.page) || 1;
        refetch();
      }
    );

    return {
      pageConfig,
      rowsPerPage,
      dataRows,
      dataCount,
      isLoaded,
      dayjs,
      selected,
      toDate,
      route,
      search,
      viewData,
      months,
      pages,
      searchInput,
      searchText,
      doSort,
      advanceFilterModal,
      filterForm,
      filterModal,
      errorMessage,
      hasError,
      isFilter,
      paginationOffset,
      exports,
      setRowsPerPage,
      rowsPerPageOption,
      offset,
      currentPage,
      startPaginationPage,
    };
  },
};
</script>
